module.exports = ".layout-wrapper .layout-content .layout-content-container {\n  padding-top: 140px; }\n\n@media (max-width: 1024px) {\n  .layout-wrapper .layout-content .layout-content-container {\n    padding-top: 50px; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admission/admission.component.scss
// module id = ./src/app/admission/admission.component.scss
// module chunks = main